import { Tooltip, TooltipTrigger, TooltipContent } from '@/lib/shadcn/ui/tooltip';
import { Badge } from '@/lib/shadcn/ui/badge';

export default function CommentStatus({ status, createdAt }) {
  if (!status || status === 'approved') return null;

  const daysToDeleteIfDeclined = Math.max(1, Math.ceil(7 - (new Date().getTime() - new Date(createdAt).getTime()) / (1000 * 60 * 60 * 24)));

  const statusConfig = {
    pending: {
      variant: 'secondary',
      label: 'Pending Review',
      tooltip: 'This comment is pending review and only visible to you',
    },
    declined: {
      variant: 'destructive',
      label: 'Declined',
      tooltip: `This comment does not meet our guidelines and will be deleted in ${daysToDeleteIfDeclined} ${daysToDeleteIfDeclined === 1 ? 'day' : 'days'}`,
    },
  };

  const config = statusConfig[status];
  if (!config) return null;

  return (
    <Tooltip>
      <TooltipTrigger>
        <Badge
          variant={config.variant}
          className="flex gap-1 rounded-lg text-xs cursor-help"
        >
          {config.label}
        </Badge>
      </TooltipTrigger>
      <TooltipContent side="top" className="text-center w-[270px]" suppressHydrationWarning>
        {config.tooltip}
      </TooltipContent>
    </Tooltip>
  );
}
